import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';
import { UtilsService } from './utils';

@Injectable()
export class CompanyLogoService {
  public logo: string;
  private readonly companyLogo = '/uas/v1/logo/{type}';

  constructor(private _loginService: LoginService,
              private _http: HttpClient,
              private utils: UtilsService) {
  }

  public set logoSrc(value: string) {
    this.logo = value;
  }

  public get logoSrc(): string {
    return this.logo;
  }

  public getCompanyLogo(challenge: string, domain: string, type): Observable<any> {
    let url = this.utils.parseTemplateString(this.companyLogo, {type});
    url = this._loginService.getUrl(url);
    const header = challenge ? this._loginService.getChallengeConfigHeader(challenge) : this._loginService.getDomainConfigHeader(domain);
    return this._http.get(url, header);
  }
}
